// Contact.js
import React, { useState, useEffect } from 'react';
import '../styles/contact.css';

function Contact() {
  const [lang, setLang] = useState(localStorage.getItem('lang') || 'fr');

  // On écoute les changements globaux de langue (si un autre composant modifie localStorage)
  useEffect(() => {
    const onLangChanged = () => {
      setLang(localStorage.getItem('lang') || 'fr');
    };

    window.addEventListener('langChanged', onLangChanged);
    return () => window.removeEventListener('langChanged', onLangChanged);
  }, []);

  return (
    <div className="contact-container">
      {/* Titre */}
      <h2>{lang === 'fr' ? 'Contactez-nous' : 'Mifandraisa aminay'}</h2>

      {/* Introduction */}
      <p>
        {lang === 'fr'
          ? 'Nous sommes disponibles sur les réseaux suivants :'
          : 'Afaka mifandray aminay amin\'ireto tambajotra ireto ianao :'}
      </p>

      <div className="contact-links">
        <a href="https://www.facebook.com/" target="_blank" rel="noreferrer">
          Facebook
        </a>
        <a href="https://www.linkedin.com/" target="_blank" rel="noreferrer">
          LinkedIn
        </a>
        <a href="https://www.tiktok.com/" target="_blank" rel="noreferrer">
          TikTok
        </a>
      </div>

      <div className="contact-info">
        <p>
          <strong>{lang === 'fr' ? 'Email' : 'Mailaka'} :</strong> contact@monsite.com
        </p>
        <p>
          <strong>{lang === 'fr' ? 'Téléphone' : 'Telefaonina'} :</strong> +261 34 12 345 67
        </p>
      </div>
    </div>
  );
}

export default Contact;
